import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {empresaStore} from "@/store/empresaStore";
import {globalStore} from "@/store/globalStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';

export class EmpresaService{
    private static instance: EmpresaService;

    baseURL= `${process.env.VUE_APP_URL}`;

    public static getInstance(){
        return this.instance || (this.instance = new this());
    }

    empresaStore = empresaStore();
    globalStore = globalStore();

    public async index(data: any) {
        this.empresaStore.loading = true;
        await http.get("getEmpresas", {params: data}).subscribe({
            next: (response) => {
                this.empresaStore.empresasListado = response.data.data;
                this.makePagination(response.data);
                this.empresaStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.empresaStore.loading = false;
            }
        })
    }


    makePagination(page: any) {
        this.empresaStore.pagination.per_page = page.per_page;
        this.empresaStore.pagination.current_page = page.current_page;
        this.empresaStore.pagination.last_page = page.last_page;
    }


    public async saveEmpresa(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.empresaStore.loading = true;
            http.post("addEmpresa", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.empresaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Empresa registrada correctamente");
                        this.empresaStore.empresa = response.data.empresa
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.empresaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async updateEmpresa(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.empresaStore.loading = true;
            http.post("updateEmpresa", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.empresaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Empresa registrada correctamente");
                        this.empresaStore.empresa = response.data.empresa
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.empresaStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async deleteEmpresa(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.empresaStore.loading = true;
            http.post("deleteEmpresa", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.empresaStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Empresa eliminada correctamente");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.empresaStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async getTipoMaterial() {
        await http.get("getTipoMaterialEmpresa").subscribe({
            next: (response:AxiosResponse) => {
                this.empresaStore.tipoMaterial = response.data;
            },
        })
    }

}